import { JSX } from 'react';
import {
    Box
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

export const DefaultAdminUserMiniManagement: (props: { message?: string }) => JSX.Element = (props: { message?: string }): JSX.Element => {

    return (
        <Box sx={ {
            width: '100%',
            height: '76vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
        } }>
            <WarningIcon sx={ { width: '150px', height: '150px', margin: '0 0 20px 0' } } />
            <h2>{ props?.message ?? "Use of this mini is currently unavailable!" }</h2>
        </Box>
    );
}